import SMP_CONFIG from './smp_config';

const getCurrentLanguage = () => {
  // If Workshop set default language for webkit then use it
  if (SMP_CONFIG.applicationConfig && SMP_CONFIG.applicationConfig.languageCode) {
    return SMP_CONFIG.applicationConfig.languageCode;
  }

  // Fallback country language code
  return SMP_CONFIG.countryConfig.defaultLanguageCode;
};

const getCountryConfigTimezone = () => {
  return SMP_CONFIG.countryConfig.defaultTimeZoneId;
};

const getApplicationCountryCode = () => {
  return SMP_CONFIG.applicationConfig.countryCode;
};

const getApplicationLanguageCode = () => {
  return SMP_CONFIG.applicationConfig.languageCode;
};

export default {
  getCurrentLanguage,
  getApplicationCountryCode,
  getApplicationLanguageCode,
  getCountryConfigTimezone
}
